import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from '../authentication/components/login.module.scss';

const BadgeStatus = ({ item }) => {
  const options = {
    0: { style: styles.inprogress_list, key: 'in_progress', label: 'IN PROGRESS' },
    1: { style: styles.approved_list, key: 'approved', label: 'APPROVED' },
    2: { style: styles.rejected_list, key: 'rejected', label: 'REJECTED' },
    3: { style: styles.draft, key: 'draft', label: 'DRAFT' },
    4: { style: styles.signatory, key: 'signatory_review', label: 'SIGNATORY REVIEW' },
    5: { style: styles.aiportstaff, key: 'airport_staff_review', label: 'AIRPORT STAFF REVIEW' },
    6: { style: styles.initiated, key: 'new', label: 'NEW' },
    7: { style: styles.expired, key: 'expired', label: 'EXPIRED' },
    8: { style: styles.lost, key: 'lost_unaccounted', label: 'LOST/UNACCOUNTED' },
    9: { style: styles.damaged, key: 'damaged', label: 'DAMAGED' },
    10: { style: styles.returned, key: 'returned', label: 'RETURNED' },
    11: { style: styles.closed_list, key: 'closed', label: 'CLOSED' },
    12: { style: styles.onhold, key: 'on_hold', label: 'ON HOLD' }
  };
  const key = Number(item);
  const statusConfig = options[key] || {
    style: styles.inprogress_list,
    key: 'in_progress',
    label: 'IN PROGRESS'
  };
  return (
    <div className={statusConfig.style}>
      <FormattedMessage
        id={`badging.list.status.${statusConfig.key}`}
        defaultMessage={statusConfig.label}
      />
    </div>
  );
};

BadgeStatus.propTypes = {
  item: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default BadgeStatus;
